export default __webpack_public_path__ + "static/icon-partnerships-15023903818f8d235c1cc5bb39d7bf9e.svg";